import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { TechniqueAnimation } from './model/technique-animation.model';
import { CreateRequestTechniqueAnimation } from './request/create-request';
import { Response } from '../../shared/models/response.model';

@Injectable({
  providedIn: 'root',
})
export class TechniqueAnimationService {
  #http = inject(HttpClient);

  readonly BASE_URL = '/techniques-animation';

  trouverTous = () => {
    return this.#http.get<Response<TechniqueAnimation>>(this.BASE_URL);
  };

  trouverParId = (id: string) => {
    return this.#http.get<TechniqueAnimation>(this.BASE_URL + '/' + id);
  };

  modifier = (technique: TechniqueAnimation) => {
    return this.#http.put<TechniqueAnimation>(this.BASE_URL + '/' + technique.id, technique);
  };

  créer = (request: CreateRequestTechniqueAnimation) => {
    return this.#http.post(this.BASE_URL, request);
  };

  supprimer = (id: string) => {
    return this.#http.delete<void>(this.BASE_URL + '/' + id);
  };
}
